import { type WalletConnectionErrorType } from '@/app/api/t/constants'

const USER_REJECTION_PATTERNS = [
  'user rejected',
  'user denied',
  'user cancelled',
  'user canceled',
  'action_rejected',
  'rejected the request',
  'request rejected',
  'transaction was rejected',
  'signature denied',
  'declined',
  '4001'
]

export function classifyWalletConnectionError(error: unknown): WalletConnectionErrorType {
  if (!error) return 'unknown'

  const message = (error instanceof Error ? error.message : String(error)).toLowerCase()

  if (USER_REJECTION_PATTERNS.some(pattern => message.includes(pattern))) {
    return 'user_rejection'
  }
  if (
    message.includes('timeout') ||
    message.includes('timed out') ||
    message.includes('request took too long')
  ) {
    return 'timeout'
  }
  if (
    message.includes('network') ||
    message.includes('connection') ||
    message.includes('disconnected') ||
    message.includes('no internet')
  ) {
    return 'network_error'
  }
  if (
    message.includes('provider') ||
    message.includes('wallet') ||
    message.includes('connector') ||
    message.includes('not found') ||
    message.includes('not installed')
  ) {
    return 'provider_error'
  }
  if (
    message.includes('chain') ||
    message.includes('unsupported') ||
    message.includes('wrong network')
  ) {
    return 'unsupported_chain'
  }

  return 'unknown'
}

export function isWalletConnectionUserRejection(error: unknown): boolean {
  return classifyWalletConnectionError(error) === 'user_rejection'
}
